import { ErrorText } from '@buoyhealth/common.buoy-input';
import Link from '@mui/material/Link';
import { Controller, type Control } from 'react-hook-form';
import { ToggleButtonGroup } from '../../Input';

const TOGGLE_OPTIONS = [
  {
    label: 'I agree to receive communications via unencrypted email.',
    value: true,
  },
];

const DoctorConfirmationDisclaimer = ({ control }: { control: Control<any, any> }) => {
  return (
    <>
      <div className="bp-inline-flex bp-flex-col bp-items-start bp-justify-start bp-gap-5 bp-text-gray-100">
        <div className="bp-font-primary-main">
          Your trust is important to us. Buoy will never share personal information outside of Buoy
          and our partner,{' '}
          <Link href="https://optimalmd.com/" target="_blank" rel="noreferrer">
            OptimalMD
          </Link>
          .
        </div>
        <div className="bp-font-primary-main">
          Please review the following statement and check the box to continue:
        </div>
        <blockquote>
          <p className="bp-font-primary-small bp-border-l-4 bp-border-solid bp-border-gray-20 bp-py-1 bp-pl-3">
            I understand that Buoy will send my doctor confirmation via regular email. Email
            correspondence will limit personal health information but will not include additional
            encryption.
          </p>
        </blockquote>

        <div>
          <Controller
            control={control}
            name="disclaimer"
            render={({ field, fieldState }) => {
              const { ref: inputRef, ...fieldProps } = field;
              return (
                <>
                  <ToggleButtonGroup
                    {...fieldProps}
                    options={TOGGLE_OPTIONS}
                    onChange={(_event, value) => {
                      field.onChange(!!value.length);
                    }}
                    multiSelect
                    value={[Boolean(field.value)]}
                    hasError={!!fieldState.error}
                  />
                  <ErrorText
                    show={!!fieldState.error}
                    message="Oops! You must agree to continue."
                  />
                </>
              );
            }}
            rules={{
              required: true,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default DoctorConfirmationDisclaimer;
